
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/libros-usados-oferta/[categoria]",
      function () {
        return require("private-next-pages/libros-usados-oferta/[categoria]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/libros-usados-oferta/[categoria]"])
      });
    }
  